import { quickEntries } from "@/mocks/portal";

interface QuickEntryProps {
  onSelectCategory: (category: string) => void;
}

export default function QuickEntry({ onSelectCategory }: QuickEntryProps) {
  return (
    <section id="entry" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600">
              <i className="ri-route-line"></i>
              直达通道
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              六个入口，少绕弯直接看
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            每个通道对应一个内容分区，点击即可跳到分类浏览并自动完成筛选，不用再一层层翻找。
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {quickEntries.map((entry) => (
            <button
              key={entry.id}
              type="button"
              onClick={() => onSelectCategory(entry.category)}
              className="group text-left rounded-card border border-background-200 bg-background-50 p-5 md:p-6 cursor-pointer transition-colors hover:border-primary-300 hover:bg-primary-50/50"
            >
              <div className="flex items-start justify-between">
                <span className="w-11 h-11 md:w-12 md:h-12 rounded-md bg-secondary-100 text-secondary-800 flex items-center justify-center transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${entry.icon} text-xl md:text-2xl`}></i>
                </span>
                <span className="text-[11px] md:text-xs text-foreground-500">{entry.count}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{entry.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                进入分区
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}